var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","version":"1.1","width":_vm.size,"height":_vm.size}},[_c('circle',{attrs:{"cx":_vm.cx,"cy":_vm.cy,"r":_vm.r,"stroke":_vm.stroke,"stroke-width":_vm.strokeWidth,"fill":_vm.fill}})])}
var staticRenderFns = []

export { render, staticRenderFns }